import React, { useState } from 'react'
import { Item } from '../../../common/snippets'
import { AcountingHeading } from '../common/AcountingHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import { focusElemnt, navigation3 } from '../../../common/helper'
import BranchwiseCollectionAndDispatchMemoCollectionTable from './BranchwiseCollectionAndDispatchMemoCollectionTable'
import useToken from '../../../helpers/useTokens'
import { useAtom, useSetAtom } from 'jotai'
import { API_CACHE_DURATION, SELECT, urls } from '../../../common/constants'
import { GetRequest, GetRequestCachedV3 } from '../../../common/api'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { showReportAtom } from './atoms'
import { useSelector } from 'react-redux'

const reportName = 'Branch Wise & Dispatch Memo Collection'

const BranchwiseCollectionAndDispatchMemoCollection = () => {
  const [, setAlert] = useAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const { loginData } = useToken()
  const roleRights = useSelector((state) => state.common.roleRights)
  const { RoleName, AllowViewAllBranchOfCityReport, AllowViewAllBranchReport } = roleRights.Table1?.[0] || {}
  const { intCompanyID } = loginData
  const [showReport, setShowReport] = useAtom(showReportAtom)
  const [sourceCityData, setSourceCityData] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [sourceBranchData, setSourceBranchData] = useState([])
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [sourceCity, setSourceCity] = useState({})
  const [sourceBranch, setSourceBranch] = useState({})
  const [tableData, setTableData] = useState([])
  const headerData = [
    {
      company: loginData.strCompanyName,
      city: sourceCity?.CityName,
      branch: sourceBranch?.BranchName,
    },
  ]
  const selectedSourceCity = (obj) => {
    setShowReport(false)
    setSourceCity(obj)
    if (obj.CityID === 0) {
      setSourceBranchData([{ BranchID: 0, BranchName: 'All' }, ...sourceBranchList])
      setSourceBranch({ BranchID: 0, BranchName: 'All' })
    } else {
      const filterSourceBranchData = sourceBranchList.filter((item) => item.cityid === obj.CityID)
      setSourceBranchData([{ BranchID: 0, BranchName: 'All' }, ...filterSourceBranchData])
      setSourceBranch({ BranchID: 0, BranchName: 'All' })
    }

  }
  const selectedSourceBranch = (obj) => {
    setShowReport(false)
    setSourceBranch(obj)
  }
  const getBranches = async () => {
    const data = {
      CompanyID: intCompanyID
    }
    const res = await GetRequestCachedV3(urls.getCollectionBranchList, data, true, API_CACHE_DURATION)
    if (res.status === 'Success') {
      const sourceCityData = res?.Data?.Table || []
      setSourceCityData([{ CityID: 0, CityName: 'All' }, ...sourceCityData])
      const ownCity = sourceCityData.find((item) => item.CityID === loginData.intBranchCityID)
      if (ownCity) {
        setSourceCity(ownCity)
        const sourceBranchData = res?.Data?.Table1 || []
        setSourceBranchList(sourceBranchData)
        const ownCityBranches = sourceBranchData.filter((item) => item.cityid === ownCity.CityID)
        setSourceBranchData(ownCityBranches)
        const ownBranch = sourceBranchData.find((item) => item.BranchID === loginData.intBranchID) || {}
        setSourceBranch(ownBranch)
      }
    } else {
      setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
    }
  }
  const getBranchCollection = async () => {
    if (Object.keys(sourceBranch.BranchID).length < 0) {
      setAlert({ show: true, msg: 'Please Select Branch', nextId: '' })
      return
    }
    const data = {
      CompanyID: intCompanyID,
      BranchID: sourceBranch.BranchID,
      FromDate: moment(fromDate).format('YYYY-MM-DD'),
      ToDate: moment(toDate).format('YYYY-MM-DD'),
      CityID: sourceCity.CityID,
    }
    setLoader(true)
    const res = await GetRequest(urls.getBranchCollection, data)
    if (res.status === 'Success') {
      setLoader(false)
      if (res.Data.Table.length === 0) {
        setAlert({ show: true, msg: 'No Data Found', nextId: '' })
        return
      }
      let reportData = res.Data.Table.map((item, index) => {
        return {
          ...item,
          sn: index + 1,
          TranDate: item.TranDate.split('T')[0],
          OldReceivedAmt: item.ReceivedAmt,
          OldReceivedBankAmt: item.ReceivedBankAmt,
          OldRemarks: item.Remarks,
          dataType: 'entry',
        }
      })
      const reportPayload = {
        id: 'branch_wise_and_dispatch_memo',
        tableData: reportData,
        reportName: reportName,
        roleName: RoleName,
        filterData: {
          sourceCity,
          sourceBranch,
        },
        headerData: headerData
      }
      const rid = Date.now().toString()

      if (!window.generatedReports) {
        window.generatedReports = {}
      }

      window.generatedReports[rid] = reportPayload

      window.open(`/view-reportV2?rid=${rid}`, "_blank")
    } else {
      setLoader(false)
      setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
    }
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
        <Box sx={{ ...sx.reportFlex, flexWrap: 'wrap' }}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'selectCompany'}
              label={'Select Company'}
              onSelect={(val) => {
              }}
              nextId={'goButton'}
              prevId={''}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              id={'goButton'}
              className="btn btn-primary"
              onKeyDown={(e) => navigation3(e, 'fromDate', 'selectCompany', () => { })}
              onClick={getBranches}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} className="input--container" style={{ zIndex: '3' }}>
            <Datepicker
              label={`Select From Date`}
              name={'from_date'}
              id={'fromDate'}
              nextId={'toDate'}
              prevId={'goButton'}
              value={fromDate}
              maxDate={toDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('SelectCity')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container" style={{ zIndex: '3' }}>
            <Datepicker
              label={`Select To Date`}
              name={'to_date'}
              id={'toDate'}
              nextId={'SelectCity'}
              prevId={'fromDate'}
              value={toDate}
              minDate={fromDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('SelectCity')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'SelectCity'}
              label={'Select City'}
              nextId={'SelectBranch'}
              prevId={'toDate'}
              data={sourceCityData}
              defaultvalue={sourceCity?.CityName || SELECT}
              dataKey={`CityName`}
              idKey={`CityID`}
              onSelect={(obj) => selectedSourceCity(obj)}
              searchPlaceholder={`Select City`}
              width="100%"
              disabled={AllowViewAllBranchReport === 0 || AllowViewAllBranchOfCityReport === 0}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'SelectBranch'}
              label={'Select Branch'}
              nextId={'generateButton'}
              prevId={'SelectCity'}
              data={sourceBranchData}
              defaultvalue={sourceBranch?.BranchName || SELECT}
              dataKey={`BranchName`}
              idKey={`BranchID`}
              onSelect={(val) => selectedSourceBranch(val)}
              isObjArr={true}
              searchPlaceholder={`Select Branch`}
              width="350px"
              disabled={AllowViewAllBranchReport === 0 && AllowViewAllBranchOfCityReport === 0}
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              id={'generateButton'}
              className="btn btn-primary"
              onClick={getBranchCollection}
              onKeyDown={(e) => navigation3(e, 'fromDate', 'SelectBranch', () => { })}
            >
              GENERATE
            </Button>
          </Item>
        </Box>
      </Item>
      <Box>
        {showReport ? (
          <BranchwiseCollectionAndDispatchMemoCollectionTable
            sourceCity={sourceCity}
            sourceBranch={sourceBranch}
            headerData={headerData}
            tableData={tableData}
            reportName={reportName}
            setTableData={setTableData}
            roleName={RoleName}
          />
        ) : (
          ''
        )}
      </Box>
    </>
  )
}
export default BranchwiseCollectionAndDispatchMemoCollection
